// JAPAN WEB CLINIC — after the order (owner 2026-10-22, ledger F-103): people who leave the Thank you page are caught when
// they come back. The cart writes 「jwc-after-checkout」 = { app, at } in this browser when it goes to checkout
// (assets/jwc-cart.js); for 48 hours after that, every page whose cart is empty (the order is most likely placed) shows a
// banner at the very top: send the order number on the app chosen in the cart, with a button that opens LINE / WhatsApp
// (the other apps go to /pages/start). Closing it keeps it closed for that checkout. Without browser storage, nothing.
// Also the WeChat ID's copy button on /pages/start (sections/jwc-start.liquid).
(function () {
  const KEY = 'jwc-after-checkout';
  const CLOSED = 'jwc-after-checkout-closed';
  const SPAN = 48 * 60 * 60 * 1000;
  const read = (key) => {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  };
  const write = (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      /* shown again on the next page */
    }
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-jwc-copy]');
    if (!button) return;
    try {
      await navigator.clipboard.writeText(button.dataset.jwcCopy);
      const label = button.textContent;
      button.textContent = button.dataset.copied;
      setTimeout(() => {
        button.textContent = label;
      }, 2000);
    } catch (e) {
      /* the ID stays readable on the page */
    }
  });

  function banner() {
    const holder = document.getElementById('JwcAfterOrderBanner');
    const dataNode = document.getElementById('JwcAfterOrderData');
    if (!holder || !dataNode || holder.dataset.hide === 'true' || Number(holder.dataset.cartCount || 0) > 0) return;
    let seen = null;
    try {
      seen = JSON.parse(read(KEY) || 'null');
    } catch (e) {
      seen = null;
    }
    const at = Number(seen?.at || 0);
    if (!at || Date.now() < at || Date.now() - at > SPAN || read(CLOSED) === String(at)) return;
    let data;
    try {
      data = JSON.parse(dataNode.textContent);
    } catch (e) {
      return;
    }
    const app = String(seen.app || '').trim();
    const link = data.links?.[app] || '';
    const name = app || 'LINE / WhatsApp / WeChat';

    const box = document.createElement('div');
    box.className = 'jwc-after-order';
    const text = document.createElement('p');
    text.className = 'jwc-after-order__text';
    text.textContent = data.text.replace(/%APP%/g, name);
    const open = document.createElement('a');
    open.className = 'jwc-after-order__open';
    if (link) {
      open.href = link;
      open.target = '_blank';
      open.rel = 'noopener';
      open.textContent = data.open.replace(/%APP%/g, app);
    } else {
      open.href = holder.dataset.start;
      open.textContent = data.more;
    }
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'jwc-after-order__close';
    close.setAttribute('aria-label', data.close);
    close.textContent = '×';
    close.addEventListener('click', () => {
      write(CLOSED, String(at));
      box.remove();
    });
    box.append(text, open, close);
    document.body.prepend(box);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', banner);
  else banner();
})();
